// gimme: conversations-inbox-ui 06/05/2020 2e71d6e614963e241a90482877a5457fbcbaab8a
'use es6';

import inboxThreadHistories from 'conversations-thread-data/thread-histories/public/reducers/inboxThreadHistories';
export default inboxThreadHistories;